import { createAuthGuard } from '@auth0/auth0-vue'

export default defineNuxtRouteMiddleware(async (_to, _from) => {
  return await createAuthGuard()(_to)
})
